"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M30.946 2H3.054a1 1 0 0 0-.787 1.617L14 18.589V33.9a.992.992 0 0 0 1.68.825l3.98-4.153a1.221 1.221 0 0 0 .34-.845V18.589L31.733 3.617A1 1 0 0 0 30.946 2z" })
);

